const IconYoutube = ({
  width = "40",
  height = "40",
  isSmall = false,
  className = "",
}) => {
  if (isSmall) {
    return (
      <svg
        width="31"
        height="31"
        viewBox="0 0 31 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className ? className : null}
      >
        <path
          d="M29.4173 8.23579C29.0824 6.99074 28.1007 6.00927 26.8558 5.67402C24.5816 5.05176 15.4845 5.05176 15.4845 5.05176C15.4845 5.05176 6.38775 5.05176 4.11352 5.65043C2.89259 5.98533 1.887 6.99091 1.5521 8.23579C0.953613 10.5098 0.953613 15.2259 0.953613 15.2259C0.953613 15.2259 0.953613 19.9658 1.5521 22.2161C1.88736 23.461 2.86864 24.4424 4.1137 24.7777C6.4117 25.4001 15.4849 25.4001 15.4849 25.4001C15.4849 25.4001 24.5816 25.4001 26.8558 24.8015C28.1009 24.4664 29.0824 23.4849 29.4176 22.24C30.0159 19.9658 30.0159 15.2499 30.0159 15.2499C30.0159 15.2499 30.0399 10.5098 29.4173 8.23579ZM12.5882 19.5828V10.869L20.1529 15.2259L12.5882 19.5828Z"
          fill="white"
        />
      </svg>
    );
  }
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : null}
      data-name="IconYoutube"
    >
      <path
        d="M29 2.5H11C6.58172 2.5 3 6.08172 3 10.5V28.5C3 32.9183 6.58172 36.5 11 36.5H29C33.4183 36.5 37 32.9183 37 28.5V10.5C37 6.08172 33.4183 2.5 29 2.5Z"
        fill="#DD352E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.2326 26.5H12.7674C11.7914 26.5 11 25.6886 11 24.688V14.312C11 13.3114 11.7914 12.5 12.7674 12.5H27.2326C28.2086 12.5 29 13.3114 29 14.312V24.688C29 25.6886 28.2086 26.5 27.2326 26.5Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5171 22.8865V16.7224C17.5171 16.403 17.92 16.2046 18.239 16.367L24.2874 19.4491C24.6007 19.6089 24.6007 20 24.2874 20.1595L18.239 23.2416C17.92 23.4043 17.5171 23.2059 17.5171 22.8865Z"
        fill="#DD352E"
      />
    </svg>
  );
};
export default IconYoutube;
